export default __webpack_public_path__ + "static/EuclidCircularB.bold-3d208ed259f6be7deb77e45e853cf992.woff2";